export async function toteUpdateUseCase(id, toteData, toteRepository) {
    const result = await toteRepository.update(id, toteData);

    const entity = new toteRepository.model(result.data.success.arguments);
    
    if (!entity.isValid()) {
        throw new Error("tote inválido");
    }

    return result;
}